(function () {
  // Homepage renders two popular-products sections and can include this asset
  // twice. Avoid double Swiper construction and duplicate Shopify listeners.
  if (window.__oonoProductCardSliderInitialized) return;
  window.__oonoProductCardSliderInitialized = true;
	const initSlider = () => {
		const sliders = document.querySelectorAll(".product-card-js");
		const dir = document.querySelector('html').getAttribute("dir");

		let nextEl = ".product-button-group .swiper-button-next";
		let prevEl = ".product-button-group .swiper-button-prev";
		if (dir === 'rtl') {
			[nextEl, prevEl] = [prevEl, nextEl];
		}
		sliders.forEach((slider, index) => {
      // Re-use initialized sliders when the theme editor reloads sections.
      if (slider.swiper && !slider.swiper.destroyed) return;
			const productSlider = new Swiper(slider, {
				pagination: {
					el: ".product-pagination .swiper-pagination",
					clickable: true,
				},
				navigation: {
					nextEl: nextEl,
					prevEl: prevEl,
				},
				allowTouchMove: true,
				990: {
					allowTouchMove: false,
				},
			});
		});
	};

	initSlider();

	document.addEventListener("shopify:section:load", function () {
		initSlider();
	});
})();
